import stylesConfig from '../../../theme/config';

const styles = {
  itemText: {
    fontSize: stylesConfig.typography.navlink,
    color: stylesConfig.colors.black,
  },
  button: {
    '&:hover': {
      background: 'transparent',
      '& .navigation-link-text p': {
        ...stylesConfig.navigationActive['& .navigation-link-text'],
      },

      '& .navigation-link-text::after': {
        ...stylesConfig.navigationActive['& .navigation-link-text::after'],
        left: '44px',
        width: '55%',
      },
    },
  },
  menuItemContainer: {
    paddingLeft: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  active: {
    '& .navigation-link-text p': {
      ...stylesConfig.navigationActive['& .navigation-link-text'],
    },

    '& .navigation-link-text::after': {
      ...stylesConfig.navigationActive['& .navigation-link-text::after'],
      left: '44px',
      width: '55%',
    },
  },
};

export default styles;
